import { SET_SEARCH_DOCUMENT_CLAIM } from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_DOCUMENT_CLAIM: {
      return [...action.payload];
    }
    default:
      return state;
  }
}
